import { gql } from "@apollo/client";

const createMutation = async (
  client,
  mutationName,
  mutation,
  variables = {}
) => {
  const respons = await client.mutate({
    mutation,
    variables,
  });
  return respons.data[mutationName] || respons;
};

const LOGIN = gql`
  mutation LoginAdmin($email: String, $password: String) {
    loginAdmin(email: $email, password: $password) {
      response {
        status
        errMsg
        id_affected
      }
      token
    }
  }
`;

export const adminLogin = async (client, { email, password }) => {
  try {
    const result = await createMutation(client, "loginAdmin", LOGIN, {
      email,
      password,
    });
    return result;
  } catch (error) {
    return { response: { errMsg: error + "" } };
  }
};

const CREATE_OPPORTUNITY = gql`
  mutation CreateOpportunity($input: OpportunityInput) {
    createOpportunity(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateOpportunity = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "CreateOpportunity",
      CREATE_OPPORTUNITY,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { response: { errMsg: error + "" } };
  }
};

const UPDATE_JOB_STATUS = gql`
  mutation UpdateStatusOpportunity($input: StatusOpportunityUpdate) {
    updateStatusOpportunity(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateStatusOpportunity = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateStatusOpportunity",
      UPDATE_JOB_STATUS,
      { input }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_OPPORTUNITY = gql`
  mutation UpdateOpportunity($input: OpportunityUpdateInput) {
    updateOpportunity(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateOpportunity = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateOpportunity",
      UPDATE_OPPORTUNITY,
      { input }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_STATUS_CANDIDATE = gql`
  mutation UpdateStatusOpportunityCandidate(
    $input: [CandidateUpdateStatusInput]
  ) {
    updateStatusOpportunityCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateStatusOpportunityCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateStatusOpportunityCandidate",
      UPDATE_STATUS_CANDIDATE,
      { input }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const ASSIGN_PSIKOTEST = gql`
  mutation AssignPsikotestDateCandidate($input: [CandidatePsikotestDateInput]) {
    assignPsikotestDateCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const AssignPsikotestDateCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "AssignPsikotestDateCandidate",
      ASSIGN_PSIKOTEST,
      { input }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const ASSIGN_MCU = gql`
  mutation AssignMedicalCheckupDateCandidate(
    $input: [CandidateMedcheckDateInput]
  ) {
    assignMedicalCheckupDateCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const AssignMedicalCheckupDateCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "AssignMedicalCheckupDateCandidate",
      ASSIGN_MCU,
      { input }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const ASSIGN_INTERVIEW = gql`
  mutation AssignInterviewDateCandidate($input: [CandidateInterviewDateInput]) {
    assignInterviewDateCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const AssignInterviewDateCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "AssignInterviewDateCandidate",
      ASSIGN_INTERVIEW,
      { input }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const ASSIGN_TECHNICAL_TEST = gql`
  mutation AssignTechnicalTestCandidate($input: [CandidateTechnicalTestInput]) {
    assignTechnicalTestCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const AssignTechnicalTestCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "AssignTechnicalTestCandidate",
      ASSIGN_TECHNICAL_TEST,
      { input }
    );
    return result
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const BLACKLIST_CANDIDATE = gql`
  mutation BlacklistCandidate($input: [BlacklistCandidateInput]) {
    blacklistCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const BlacklistCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "BlacklistCandidate",
      BLACKLIST_CANDIDATE,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const DELETE_JOBDESC_BY_ID = gql`
  mutation DeleteJobDescByID($deleteJobDescByIdId: Int!) {
    deleteJobDescByID(id: $deleteJobDescByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const DeleteJobDescByID = async (client, deleteJobDescByIdId) => {
  try {
    const result = await createMutation(
      client,
      "DeleteJobDescByID",
      DELETE_JOBDESC_BY_ID,
      {
        deleteJobDescByIdId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const DELETE_JOBREQ_BY_ID = gql`
  mutation DeleteRequirementByID($deleteRequirementByIdId: Int!) {
    deleteRequirementByID(id: $deleteRequirementByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const DeleteRequirementByID = async (
  client,
  deleteRequirementByIdId
) => {
  try {
    const result = await createMutation(
      client,
      "DeleteRequirementByID",
      DELETE_JOBREQ_BY_ID,
      {
        deleteRequirementByIdId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_JOB_DESC_BY_ID = gql`
  mutation UpdateJobDescByID($input: UpdateJobDesc) {
    updateJobDescByID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateJobDescByID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateJobDescByID",
      UPDATE_JOB_DESC_BY_ID,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_JOBREQ_BY_ID = gql`
  mutation UpdateRequirementByID($input: UpdateRequirement) {
    updateRequirementByID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateRequirementByID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateRequirementByID",
      UPDATE_JOBREQ_BY_ID,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const ADD_JOBDESC = gql`
  mutation CreateJobDescByOpportunityID(
    $input: OpportunityExistingInputJobDesc
  ) {
    createJobDescByOpportunityID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateJobDescByOpportunityID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "CreateJobDescByOpportunityID",
      ADD_JOBDESC,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const ADD_REQUIREMENT = gql`
  mutation CreateRequirementByOpportunityID(
    $input: OpportunityExistingInputRequirement
  ) {
    createRequirementByOpportunityID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateRequirementByOpportunityID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "CreateRequirementByOpportunityID",
      ADD_REQUIREMENT,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const CREATE_MASTER_CLINIC = gql`
  mutation CreateMasterClinic($input: MasterClinicInput) {
    createMasterClinic(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateMasterClinic = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "CreateMasterClinic",
      CREATE_MASTER_CLINIC,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const CREATE_INTERVIEW_LOCATION = gql`
  mutation CreateMasterLokasiInterview($input: MasterLokasiInterviewInput) {
    createMasterLokasiInterview(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateMasterLokasiInterview = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "CreateMasterLokasiInterview",
      CREATE_INTERVIEW_LOCATION,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_MASTER_INTERVIEW_LOCATION = gql`
  mutation UpdateMasterLokasiInterviewById(
    $input: MasterLokasiInterviewUpdate
  ) {
    updateMasterLokasiInterviewById(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateMasterLokasiInterviewById = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateMasterLokasiInterviewById",
      UPDATE_MASTER_INTERVIEW_LOCATION,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const DELETE_MASTER_INTV_LOCATION = gql`
  mutation DeleteMasterLokasiInterviewById(
    $deleteMasterLokasiInterviewByIdId: Int!
  ) {
    deleteMasterLokasiInterviewById(id: $deleteMasterLokasiInterviewByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const DeleteMasterLokasiInterviewById = async (
  client,
  deleteMasterLokasiInterviewByIdId
) => {
  try {
    const result = await createMutation(
      client,
      "DeleteMasterLokasiInterviewById",
      DELETE_MASTER_INTV_LOCATION,
      {
        deleteMasterLokasiInterviewByIdId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const CREATE_MASTER_DIVISION = gql`
  mutation CreateMasterDivision($input: MasterDivisionInput) {
    createMasterDivision(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateMasterDivision = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "CreateMasterDivision",
      CREATE_MASTER_DIVISION,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_MASTER_CLINIC = gql`
  mutation UpdateMasterClinicById($input: MasterClinicUpdate) {
    updateMasterClinicById(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateMasterClinicById = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateMasterDivisionByID",
      UPDATE_MASTER_CLINIC,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const DELETE_MASTER_CLINIC = gql`
  mutation DeleteMasterClinic($deleteMasterClinicId: Int!) {
    deleteMasterClinic(id: $deleteMasterClinicId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const DeleteMasterClinicID = async (client, deleteMasterClinicId) => {
  try {
    const result = await createMutation(
      client,
      "DeleteMasterClinic",
      DELETE_MASTER_CLINIC,
      {
        deleteMasterClinicId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const DELETE_DETAIL_CLINIC = gql`
  mutation DeleteDetailClinicById($deleteDetailClinicByIdId: [Int!]) {
    deleteDetailClinicById(id: $deleteDetailClinicByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const deleteDetailClinicById = async (
  client,
  deleteDetailClinicByIdId
) => {
  try {
    const result = await createMutation(
      client,
      "DeleteDetailClinicById",
      DELETE_DETAIL_CLINIC,
      {
        deleteDetailClinicByIdId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_MASTER_DIVISION = gql`
  mutation UpdateMasterDivisionByID($input: MasterDivisionUpdateInput) {
    updateMasterDivisionByID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateMasterDivisionByID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "UpdateMasterDivisionByID",
      UPDATE_MASTER_DIVISION,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const DELETE_MASTER_DIVISION = gql`
  mutation DeleteMasterDivisionByID($deleteMasterDivisionByIdId: Int!) {
    deleteMasterDivisionByID(id: $deleteMasterDivisionByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const DeleteMasterDivisionByID = async (
  client,
  deleteMasterDivisionByIdId
) => {
  try {
    const result = await createMutation(
      client,
      "DeleteMasterDivisionByID",
      DELETE_MASTER_DIVISION,
      {
        deleteMasterDivisionByIdId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_OPPORTUNITY_CANDIDATE = gql`
  mutation UpdateOpportunityCandidate(
    $candidateId: Int!
    $opportunityId: Int!
    $newOpportunityId: Int!
  ) {
    updateOpportunityCandidate(
      candidate_id: $candidateId
      opportunity_id: $opportunityId
      new_opportunity_id: $newOpportunityId
    ) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateOpportunityCandidate = async (
  client,
  candidateId,
  opportunityId,
  newOpportunityId
) => {
  try {
    const result = await createMutation(
      client,
      "UpdateOpportunityCandidate",
      UPDATE_OPPORTUNITY_CANDIDATE,
      {
        candidateId,
        opportunityId,
        newOpportunityId,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_RECRUITMENT_RESULT = gql`
  mutation UpdateCandidateRecruitmentResult(
    $input: CandidateRecruitmentResultUpdate
  ) {
    updateCandidateRecruitmentResult(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateRecruitmentResult = async (client, input) => {
  try {
    const resultUpdate = createMutation(
      client,
      "updateCandidateRecruitmentResult",
      UPDATE_RECRUITMENT_RESULT,
      {
        input,
      }
    );
    return resultUpdate;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const INSERT_MEDIA_LANDING_PAGE = gql`
  mutation InsertMediaLandingPage($input: MasterLandingPageInput) {
    insertMediaLandingPage(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const InsertMediaLandingPage = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "insertMediaLandingPage",
      INSERT_MEDIA_LANDING_PAGE,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_MEDIA_LANDING_PAGE = gql`
  mutation UpdateMediaLandingPage($input: LinkMediaUpdateInput) {
    updateMediaLandingPage(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateMediaLandingPage = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateMediaLandingPage",
      UPDATE_MEDIA_LANDING_PAGE,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};

const UPDATE_STATUS_MEDIA_LANDING_PAGE = gql`
  mutation UpdateStatusMediaLandingPage($input: StatusLandingPageUpdateInput) {
    updateStatusMediaLandingPage(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateStatusMediaLandingPage = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateStatusMediaLandingPage",
      UPDATE_STATUS_MEDIA_LANDING_PAGE,
      {
        input,
      }
    );
    return result;
  } catch (error) {
    return { respon: { errMsg: error + "" } };
  }
};
